<template>
  <layout>
    <template v-slot:title>Settings</template>
    <sharedo-instance />
    <bounding-boxes v-if="isTemplateAuthor" class="mt-1" />
    <expert-mode class="mt-1" />
    <diagnostics class="mt-1" />
    <environment class="mt-1" />
  </layout>
</template>
<script>
import SharedoInstance from "@/components/settings/SharedoInstance.vue";
import Environment from "@/components/settings/Environment.vue";
import ExpertMode from "@/components/settings/ExpertMode.vue";
import Diagnostics from "@/components/settings/Diagnostics.vue";
import BoundingBoxes from "@/components/settings/BoundingBoxes.vue";
import profile from "@/mixins/profile";
import { ADMIN_DOCUMENT_ASSEMBLY } from "@/constants/permissions";

export default {
  components: { SharedoInstance, Environment, ExpertMode, Diagnostics, BoundingBoxes },
  mixins: [profile],
  computed: {
    isTemplateAuthor: function () {
      return this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY);
    },
  },
};
</script>
